import React from 'react'
import { navigate } from 'gatsby-link'
import Layout from '../../components/LayoutENG'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default class IndexENG extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isValidated: false }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': form.getAttribute('name'),
        ...this.state,
      }),
    })
      .then(() => navigate(form.getAttribute('action')))
      .catch(error => alert(error))
  }

  render() {
    return (
      <Layout>
        <section className="section">
          <div className="container">

            <div className="content">
              <div className="grid-containerKontaktowy">
                <div className="formularzkontaktowy">
                  <h1>Contact form</h1><form
                  name="contact"
                  action="https://formspree.io/mbjgkoeo"
                  method="POST"
                >
                  {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                  <input type="hidden" name="form-name" value="contact" />
                  <div hidden>
                    <label>
                      Don’t fill this out:{' '}
                      <input name="bot-field" onChange={this.handleChange} />
                    </label>
                  </div>
                  <div className="field">
                    <label className="label" htmlFor={'name'}>
                      Name
                  </label>
                    <div className="control">
                      <input
                        className="input"
                        type={'text'}
                        name={'name'}
                        onChange={this.handleChange}
                        id={'name'}
                        required={true}
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label className="label" htmlFor={'email'}>
                      Email
                  </label>
                    <div className="control">
                      <input
                        className="input"
                        onChange={this.handleChange}
                        id={'email'}
                        required={true}
                        type="text" name="_replyto"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <label className="label" htmlFor={'message'}>
                      Message
                  </label>
                    <div className="control">
                      <textarea
                        className="textarea"

                        onChange={this.handleChange}
                        id={'message'}
                        required={true}
                        name="message"
                      />
                    </div>
                  </div>
                  <div className="field">
                    <button className="button is-link" type="submit">
                      Send message
                  </button>
                  </div>
                </form></div>
                <div className="kontakt"><h1>Contact</h1>
                  <p>
                    Ekochron<br></br>
                    43-426 Dębowiec Ogrodzona, St. Przemysłowa  15<br></br>
                    Upper Silesia, Poland<br></br>
                    GPS: N 49,768314 E 18,723047   <br></br><br></br>
                    phone +48 33 857 90 10, +48 33 853 32 91
                    </p>

                  <p className="kontaktH5">Customer Service:</p>
                  <p> phone +48 33 857 90 10 ext. 21, 26<br></br>
                    <a href="mailto:sprzedaz@ekochron.pl">e-mail: sprzedaz@ekochron.pl</a></p>
                  <p className="kontaktH5">Technical support:</p>
                  <p> phone 33 857 90 10 ext. 17<br></br>
                    <a href="mailto:doradca@ekochron.pl">e-mail: doradca@ekochron.pl</a></p>

                </div>
                <div className="jakzamawiac">
                  <h1>How to place orders?</h1>
                  <p>Ekochron Brand products may be ordered in a couple of ways:<br></br>
                    📞🠞by phone <b>+48 33 857 90 10</b>, <b>+48 33 853 32 91</b> ext. 21, 26;<br></br>
                    📧🠞by e-mail: sprzedaz@ekochron.pl;<br></br>
                    📝🠞via an order form available below or in person in the company seat.<br></br>
                    </p>
                  <ul>
                    <li>Sales department work from Monday to Friday between 7.00 a.m. and 3.00 p.m.</li>
                    <li>Ordering is equivalent to booking.</li>
                    <li>If goods are not in stock we specify an order readiness date and inform the customer by phone or by mail.</li>
                    <li>Lead time is 5 working days and for non-standard products – up to 3 weeks’ time.</li>
                  </ul>


                </div>
              </div>


            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
